import { render, staticRenderFns } from "./SemiFinishedProductManagement.vue?vue&type=template&id=5681c34c&scoped=true"
import script from "./SemiFinishedProductManagement.vue?vue&type=script&lang=js"
export * from "./SemiFinishedProductManagement.vue?vue&type=script&lang=js"
import style0 from "./SemiFinishedProductManagement.vue?vue&type=style&index=0&id=5681c34c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5681c34c",
  null
  
)

export default component.exports